import { render } from "./ManagementContent.vue?vue&type=template&id=a26f6a96&ts=true"
import script from "./ManagementContent.vue?vue&type=script&lang=ts"
export * from "./ManagementContent.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/armieisla/workspace/charmedteq/icare/icare-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__